/* SHADOW v3 — header state, reveals, product gallery/qty/tabs, withdrawal form */
(function () {
  var nav = document.getElementById('nav');
  /* v5: sider med fuldskærms-hero (forside og Om SHADOW) får gennemsigtig menu over billedet */
  var isIndex = document.body.classList.contains('tpl-index') || !!document.querySelector('.hero4');
  var lights = isIndex ? Array.prototype.slice.call(document.querySelectorAll('[data-light], .footer')) : [];
  function updateNav() {
    if (!nav) return;
    nav.classList.toggle('is-scrolled', window.scrollY > 40);
    if (!isIndex) { nav.classList.add('is-light'); return; }
    var y = nav.offsetHeight / 2;
    nav.classList.toggle('is-light', lights.some(function (s) { var r = s.getBoundingClientRect(); return r.top <= y && r.bottom >= y; }));
  }
  window.addEventListener('scroll', updateNav, { passive: true });
  updateNav();

  var items = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    items.forEach(function (el) { io.observe(el); });
  } else { items.forEach(function (el) { el.classList.add('is-in'); }); }

  /* Gallery */
  var main = document.querySelector('.product__main');
  document.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.thumb').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      if (main) { main.src = t.dataset.src; main.removeAttribute('srcset'); }
    });
  });

  /* Quantity */
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('.qty__input');
    q.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(parseInt(input.min || '1', 10), Math.min(99, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10)));
        input.value = n;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Tabs */
  var tabs = Array.prototype.slice.call(document.querySelectorAll('.tabs__tab'));
  function select(tab, focus) {
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on);
      t.tabIndex = on ? 0 : -1;
      var pane = document.getElementById(t.getAttribute('aria-controls'));
      if (pane) pane.hidden = !on;
    });
    if (focus) tab.focus();
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { select(t); });
    t.addEventListener('keydown', function (e) {
      var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (d) select(tabs[(i + d + tabs.length) % tabs.length], true);
    });
  });

  /* Fortryd køb — posts to the endpoint in the form's action; the service must email an instant receipt */
  var form = document.getElementById('withdraw');
  if (form) {
    var msg = form.querySelector('.withdraw__msg');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var endpoint = form.getAttribute('action') || '';
      if (endpoint.indexOf('http') !== 0) {
        msg.textContent = 'Formularen er ikke koblet til endnu. Skriv i stedet til os på mail.';
        msg.className = 'withdraw__msg is-error';
        return;
      }
      var btn = form.querySelector('button');
      btn.disabled = true;
      var data = new FormData(form);
      data.append('tidspunkt', new Date().toISOString());
      fetch(endpoint, { method: 'POST', body: data, headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          var when = new Date().toLocaleString('da-DK', { dateStyle: 'long', timeStyle: 'short' });
          form.querySelectorAll('label, button').forEach(function (el) { el.hidden = true; });
          msg.textContent = 'Tak. Vi har modtaget din fortrydelse ' + when + '. Kvitteringen er sendt til ' + data.get('email') + '.';
          msg.className = 'withdraw__msg is-ok';
        })
        .catch(function () {
          btn.disabled = false;
          msg.textContent = 'Noget gik galt. Prøv igen, eller skriv til os på mail.';
          msg.className = 'withdraw__msg is-error';
        });
    });
  }
})();
